module.exports = __webpack_public_path__ + "assets/75d19004c903e5dbdaa83c46ad162708.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/cz/video.mp4
// module id = 370
// module chunks = 1